import {UserMenuDefaultProps} from './types';

export const defaultProps: UserMenuDefaultProps = {
    compact: false,
    size: 'l',
    showUserInfo: false,
    cloudAuth: true,
    showSsoLogin: false,
};
